import { Pipe, PipeTransform } from '@angular/core';
import { Customer } from '../../classes/customer';

@Pipe({
  name: 'customerCityFilter',
  pure: false
})
export class CustomerCityFilterPipe implements PipeTransform {

  transform(customerList: Array<Customer>, filterValue: string): any {
    if (!customerList || !filterValue) {
      return customerList;
    }
    const normalizedFilter = filterValue.toLowerCase().trim();
    return customerList.filter(customer =>
      (customer.HeadOffice || '').toLowerCase().indexOf(normalizedFilter) !== -1
      || (customer.City || '').toLowerCase().indexOf(normalizedFilter) !== -1
    );
  }

}
